import { useEffect } from 'react';
import { X } from 'lucide-react';

export function Modal({ open, onClose, title, children, footer, size }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  if (!open) return null;
  const maxWidth = size === 'lg' ? 900 : size === 'sm' ? 480 : 720;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ maxWidth }} onClick={(e) => e.stopPropagation()}>
        {title && (
          <div className="modal-header">
            <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>{title}</h3>
            <button className="btn btn-ghost btn-icon" onClick={onClose} aria-label="Fechar">
              <X size={18} />
            </button>
          </div>
        )}
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
